// extracted by mini-css-extract-plugin
module.exports = {"bulletContainer":"Pill_bulletContainer__2Vogk","warning":"Pill_warning__2XGrD","error":"Pill_error__RTN6S"};